<app-header></app-header>
<div class="container">
  <div class="creditor-portal contact-msg">
    <div class="row ">
      <div class="col-lg-8 offset-lg-2  col-12">
        <h3>

          </h3>
          <ul class="my-5 text-center">
            <li>Your message has been delivered.</li>
            
          </ul>
          <div class="text-center">
            <button class="primary-button bg-trasparent" (click)="redirectToHomePage()">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
